import { List } from 'antd';
import styled from '@emotion/styled';

const StyledListItem = styled(List.Item)`
    padding-left: 10px !important;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #333333;
    }
`;

export default StyledListItem;